// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"9b79d759","843":"be0799de","990":"165d387a"}[chunkId] + ".chunk.js";
};